var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareJobActiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81147 7.2714C4.5553 6.81128 4.064 6.5 3.5 6.5C2.67157 6.5 2 7.17157 2 8C2 8.82843 2.67157 9.5 3.5 9.5C4.064 9.5 4.5553 9.18872 4.81147 8.7286M4.81147 7.2714C4.93158 7.48713 5 7.73557 5 8C5 8.26443 4.93158 8.51287 4.81147 8.7286M4.81147 7.2714L11.1885 3.7286M4.81147 8.7286L11.1885 12.2714M11.1885 12.2714C11.0684 12.4871 11 12.7356 11 13C11 13.8284 11.6716 14.5 12.5 14.5C13.3284 14.5 14 13.8284 14 13C14 12.1716 13.3284 11.5 12.5 11.5C11.936 11.5 11.4447 11.8113 11.1885 12.2714ZM11.1885 3.7286C11.4447 4.18872 11.936 4.5 12.5 4.5C13.3284 4.5 14 3.82843 14 3C14 2.17157 13.3284 1.5 12.5 1.5C11.6716 1.5 11 2.17157 11 3C11 3.26443 11.0684 3.51287 11.1885 3.7286Z",
    stroke: "#150349",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareJobActiveIcon);
export default __webpack_public_path__ + "static/media/ShareJobActiveIcon.2675fa95406407077f809feca29d558d.svg";
export { ForwardRef as ReactComponent };